import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, provide, watch } from 'vue'
  import GenericContent from '@/components/curated-content/GenericContent.vue'
  import { BookmarksModule } from '@/store/modules/Bookmarks'
  import useSegment from '@/composables/useSegment'
  import { CourseModule } from '@/store/modules/course'
  import useCourse from '@/composables/useCourse'
  import useCommonMixin from '@/composables/useCommonMixin'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Bookmarks',
  setup(__props) {

  const { trackPage, pageViewed } = useSegment()
  const { fetchCourses } = useCourse()
  const { setIsLoadingComponentViewData } = useCommonMixin()
  const limit = 10
  provide('itemPurpose', 'bookmarks')

  const userBookmarks = computed(() => {
    return Object.values(BookmarksModule.bookmarks)
  })

  const loadingBookmarks = computed(() => !userBookmarks.value.length)

  if (!CourseModule.courses && userBookmarks.value.length > 0) {
    fetchCourses()
  }

  onMounted(() => {
    trackPage('Bookmarks')
    pageViewed('Bookmarks')
  })

  watch(loadingBookmarks, (value) => {
    setIsLoadingComponentViewData(value)
  })

return { __sfc: true,trackPage, pageViewed, fetchCourses, setIsLoadingComponentViewData, limit, userBookmarks, loadingBookmarks, computed, onMounted, provide, watch, GenericContent, BookmarksModule, useSegment, CourseModule, useCourse, useCommonMixin }
}

})